import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { DealerUserStatusName, UserStatus } from '../../constants/UserStatus';
import { dateToString } from '../../common/utils/date/Date.utils';
import { getImpersonate } from '../UsersActions';
import editIcon from '../../assets/img/icons/edit-primary.svg';
import loginIcon from '../../assets/img/icons/login-primary.svg';

function UsersTableRow({ item }) {
  const {
    id,
    serial,
    firstName,
    lastName,
    email,
    registrationDate,
    organization,
    status,
    postalCode,
  } = item;

  const dispatch = useDispatch();

  const handleLoginClick = (id, event) => {
    event.stopPropagation();
    dispatch(
      getImpersonate(id, (token) => {
        const DEALER_URL = process.env.REACT_APP_DEALER_URL || 'http://localhost:3000';
        window.open(`${DEALER_URL}/impersonate?om=${id}&t=${token}`, '_blank');
      }),
    );
  };

  return (
    <>
      <td className="fw-semibold users-table__td">{serial}</td>
      <td className="users-table__td">{firstName}</td>
      <td className="users-table__td">{lastName}</td>
      <td className="users-table__td users-table__email">{email}</td>
      <td className="users-table__td">
        {(registrationDate && dateToString(registrationDate)) ?? '-'}
      </td>
      <td className="users-table__td users-table__dealer">{organization?.tradeName ?? '-'}</td>
      <td className="users-table__td users-table__status">{DealerUserStatusName?.[status]}</td>
      <td className="users-table__td">{postalCode || '-'}</td>
      <td className="text-right">
        {status !== UserStatus.PENDING && status !== UserStatus.REJECTED && (
          <>
            <Button
              className="btn-icon rounded-circle btn-ghost-light"
              id={`tooltip_login${id}`}
              size="sm"
              type="button"
              onClick={(event) => handleLoginClick(id, event)}
            >
              <img src={loginIcon} alt="Login icon" />
            </Button>
            <UncontrolledTooltip
              className="uncontrolled-tooltip"
              delay={0}
              target={`tooltip_login${id}`}
            >
              Log In
            </UncontrolledTooltip>
          </>
        )}
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          id={`tooltip${id}`}
          size="sm"
          type="button"
        >
          <img src={editIcon} alt="Edit icon" />
        </Button>
        <UncontrolledTooltip
          className="uncontrolled-tooltip"
          delay={0}
          target={`tooltip${id}`}
        >
          Edit
        </UncontrolledTooltip>
      </td>
    </>
  );
}

export default UsersTableRow;
